import { useEffect, useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

// Fetches the timeline payload once. Returns { data, loading }.
export function useTimelineData() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    api
      .get("/kg/timeline")
      .then((res) => alive && setData(res.data))
      .catch(() => alive && toast.error("Could not load the timeline."))
      .finally(() => alive && setLoading(false));
    return () => {
      alive = false;
    };
  }, []);

  return { data, loading };
}
